import functions from "./functions";
var vwFechProcDespesas = {
  async getWithPagination(page, pageSize, sort, sortDesc, filters) {
    var query = `query vwFechProcDespesas($filters:VwFechProcDespesaFiltersInput!){
      vwFechProcDespesas( sort:"${sort}${
      sortDesc ? ":desc" : ""
    }" filters:$filters ,pagination:{page:${page},pageSize:${pageSize}}){
        meta{
          pagination{
            total
            pageSize
            page
          }
        }
        data{
          id
          attributes{
          FIL_COD
          PRI_COD
          REF_EXTERNA
          CTA_PROJETO_HON_DESPACHANTE
          VL_LANCAR_HON_DESPACHANTE
          CTA_PROJETO_TX_EXPEDIENTE
          VL_LANCAR_TAXA_EXPEDIENTE
          CTA_PROJETO_AVERB_SEGURO
          VL_LANCAR_AVERB_SEGURO
          CTA_PROJETO_CORRET_CAMBIO
          VL_LANCAR_CORRET_CAMBIO
          VL_LANCAR_EMISSAO_LI
          LANC_OUTRAS_DESP_IMPORTACAO
          VL_TOT_DESPESAS
          VL_TOT_LANCAMENTOS
          VL_TOT_NFS_SERVICO
          VL_DIFERENCA
          FAZER_LANCAMENTO
          DISPONIVEL_FECHAMENTO
          }
        }
      }
    }
    `;

    var graphql = JSON.stringify({
      query,
      variables: {
        filters,
      },
    });
    var url = `${process.env.VUE_APP_STRAPI_URL}/graphql`;
    var res = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${process.env.VUE_APP_STRAPI_TOKEN}`,
        "Content-Type": "application/json",
      },
      body: graphql,
    })
      .then((res) => {
        if (window.debug) console.log(res);
        return res.json();
      })
      .then((json) => {
        if (window.debug) console.log(json);
        return json;
      });

    const end = Date.now();
    if (window.debug)
      console.log(
        `Execution getWithPagination vwFechProcDespesas time: ${
          (end - start) / 1000
        } s`
      );

    const pagination = res?.data?.vwFechProcDespesas?.meta?.pagination;
    const values = functions.sanitize(res.data.vwFechProcDespesas.data);
    return { values, pagination };
  },
};

export default vwFechProcDespesas;
